export const getConfirmarForm = () => ({
    txtAvisoPrivacidad: {
        name: "txtAvisoPrivacidad",
        label: "He leído y acepto el aviso de privacidad",
        label2: "Acepto que los datos de la solicitud original generada por el proveedor prospecto serán reemplazados por la información editada y no se podrá recuperar",
        value: false,
        required: true,
        error: false,
        helper: "Para continuar, acepte el aviso de privacidad",
        helper2: "Para continuar, acepte la declaración de reemplazo e información",
    },
});
